import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { storeLogger } from 'ngrx-store-logger';

import { environment } from '../../environments/environment';
import { createCourseKey, createCourseReducer, CreateCourseState } from './create-course.reducer';
import { createILClassKey, createILClassReducer, CreateILClassState } from './create-il-class.reducer';
import { currentStorefrontKey, currentStorefrontReducer, CurrentStorefrontState } from './current-storefront.reducer';
import { featurePanelReducer, FeaturePanelState, panelFeatureKey } from './feature-panel.reducer';
import { organizationsKey, organizationsReducer, OrganizationsState } from './organizations.reducer';
import { rapidqlKey, rapidqlReducer, RapidqlState } from './rapidql.reducer';
import { revenueFiltersKey, revenueFiltersReducer, RevenueFiltersState } from './revenue-filters.reducer';
import { routeGuardKey, routeGuardReducer, RouteGuardState } from './route-guard.reducer';
import { sidebarFeatureKey, sidebarReducer, SidebarState } from './sidebar.reducer';

export interface State {
  [sidebarFeatureKey]: SidebarState;
  [panelFeatureKey]: FeaturePanelState;
  [organizationsKey]: OrganizationsState;
  [createILClassKey]: CreateILClassState;
  [createCourseKey]: CreateCourseState;
  [currentStorefrontKey]: CurrentStorefrontState;
  [revenueFiltersKey]: RevenueFiltersState;
  [rapidqlKey]: RapidqlState;
  [routeGuardKey]: RouteGuardState;
}

export const reducers: ActionReducerMap<State> = {
  [sidebarFeatureKey]: sidebarReducer,
  [panelFeatureKey]: featurePanelReducer,
  [organizationsKey]: organizationsReducer,
  [createILClassKey]: createILClassReducer,
  [createCourseKey]: createCourseReducer,
  [currentStorefrontKey]: currentStorefrontReducer,
  [revenueFiltersKey]: revenueFiltersReducer,
  [rapidqlKey]: rapidqlReducer,
  [routeGuardKey]: routeGuardReducer
};

export function logger(reducer: ActionReducer<State>): any {
  return storeLogger({ collapsed: true })(reducer);
}

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [
      sidebarFeatureKey,
      panelFeatureKey,
      organizationsKey,
      createILClassKey,
      currentStorefrontKey,
      revenueFiltersKey,
      rapidqlKey,
      routeGuardKey
    ],
    rehydrate: true
  })(reducer);
}

export const metaReducers: MetaReducer<State>[] = environment.production
  ? [localStorageSyncReducer]
  : [localStorageSyncReducer, logger];
